import { ILabelOption } from '../../interface/Label'

export const defaultLabelOption: Readonly<Required<ILabelOption>> = {
  defaultColor: '#1976d2',
  defaultBackgroundColor: '#e3f2fd',
  defaultBorderRadius: 4,
  defaultPadding: [4, 4, 4, 4]
}